import type { IconSvgObject } from './types';

const FileYenIcon: IconSvgObject = [
  ["path", { d: "M12 22.0015H5C3.89543 22.0015 3 21.1061 3 20.0015V9.81666C3 9.28552 3.21128 8.77619 3.58724 8.401L9.41585 2.58433C9.7908 2.21014 10.2989 1.99999 10.8286 1.99999H18C19.1046 1.99999 20 2.89542 20 3.99999V8.98703", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9.00145H8C9.10457 9.00145 10 8.10602 10 7.00145V2.00145", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 13C15.2 13.9167 16.08 15.5 18 16.5M18 16.5C19.92 15.5 20.8 13.9167 21 13M18 16.5V22.0002M20.5 18.6827H15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileYenIcon;
